export const SHAPES = {
  FLAT: 'FL',
  HEX: 'HX',
  ROUND: 'RD',
  SQUARE: 'SQ',
  TUBE: 'TU',
} as const;
